import { render, staticRenderFns } from "./ser_account.vue?vue&type=template&id=4ef671ca&scoped=true&"
import script from "./ser_account.vue?vue&type=script&lang=js&"
export * from "./ser_account.vue?vue&type=script&lang=js&"
import style0 from "./ser_account.vue?vue&type=style&index=0&id=4ef671ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef671ca",
  null
  
)

export default component.exports